/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoPoint } from './GeoPoint';
import {
    GeoPointFromJSON,
    GeoPointFromJSONTyped,
    GeoPointToJSON,
    GeoPointToJSONTyped,
} from './GeoPoint';

/**
 * 
 * @export
 * @interface NewTown
 */
export interface NewTown {
    /**
     * 
     * @type {string}
     * @memberof NewTown
     */
    name?: string;
    /**
     * 
     * @type {GeoPoint}
     * @memberof NewTown
     */
    geo?: GeoPoint;
    /**
     * 
     * @type {number}
     * @memberof NewTown
     */
    parishId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewTown
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewTown interface.
 */
export function instanceOfNewTown(value: object): value is NewTown {
    return true;
}

export function NewTownFromJSON(json: any): NewTown {
    return NewTownFromJSONTyped(json, false);
}

export function NewTownFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewTown {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'geo': json['geo'] == null ? undefined : GeoPointFromJSON(json['geo']),
        'parishId': json['parishId'] == null ? undefined : json['parishId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewTownToJSON(json: any): NewTown {
    return NewTownToJSONTyped(json, false);
}

export function NewTownToJSONTyped(value?: NewTown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'geo': GeoPointToJSON(value['geo']),
        'parishId': value['parishId'],
        'courierId': value['courierId'],
    };
}

